import { useContext, useEffect, useState } from "react";
import Input from "../../material/input/Input";
import Breadcrumb from "../breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../headBar/HeadBar";
import * as publicApi from "../../../service/publicApi";
import * as regex from "../../../service/regex";
import Button from "../../material/button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import PasswordInput from "../../material/passwordInput/PasswordInput";
import { CurrentUserContext } from "../../../App";
import { formatTime } from "../searchpatient/PatientComponent";
import { RedirectCode400 } from "../../RedirectCode400";

export default function OtpRequest() {
  const nav = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);
  const location = useLocation();
  const data = location.state;
  //otp
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [otpData, setOtpData] = useState(data?.otp);
  const [otp, setOtp] = useState("");
  const [otpConfirm, setOtpConfirm] = useState(false);
  const [resetOtp, setResetOtp] = useState(false);

  //newpass
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userData, setUserData] = useState();

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ลืมรหัสผ่าน", url: "/forgotPassword" },
    otpConfirm
      ? { name: "ยืนยันรหัส OTP", url: "/forgotPassword/otpRequest" }
      : { name: "ตั้งค่ารหัสผ่านใหม่", url: "/forgotPassword/newPassword" },
  ];

  useEffect(() => {
    clearInterval();
    const hasVisited = sessionStorage.getItem("hasVisitedPage");
    if (!otpData) {
      nav(RedirectCode400);
    }
    if (!hasVisited) {
      sessionStorage.setItem("hasVisitedPage", "true");
      setResetOtp(true);
    }
  }, []);

  useEffect(() => {
    if (resetOtp && otpData) {
      countDown();
    }
  }, [resetOtp]);

  useEffect(() => {
    if (otp.length === 6) {
      if (otpData) {
        verifyOtp();
      }
    }
  }, [otp]);

  const handleOtpChange = (e) => {
    setOtp(e);
  };
  const generateOTP = async () => {
    if (!resetOtp) {
      if (otpData.otp_count == 0) {
        setIsMessage({
          type: "warning",
          data: "คุณขอรหัสมากเกินไป กรุณาเริ่มทำรายการใหม่",
        });
        nav("/forgotPassword");
        return;
      }
      let res = await publicApi.requestOtp({
        phone_number: data?.phone_number,
        token: data?.otp.token,
      });
      if (res) {
        if (res["data"]["code"] === 200) {
          setResetOtp(true);
          setOtpData(res["data"]["data"]);
        } else if (res["data"]["code"] === 400) {
          setIsMessage({ type: "warning", data: res["data"]["message_th"] });
        } else {
          setIsMessage({ type: "error", data: "เกิดข้อผิดพลาด" });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }
  };

  const countDown = async () => {
    if (resetOtp) {
      setTimeRemaining(30);
      const interval = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(interval);
            setResetOtp(false);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }
  };

  const verifyOtp = async () => {
    if (!otp) {
      setIsMessage({ type: "warning", data: "กรุณากรอก OTP" });
      return;
    }

    if (otp.length !== 6) {
      setIsMessage({ type: "warning", data: "กรุณาตรวจสอบ OTP" });
      return;
    }
    let res = await publicApi.verifyOtp({
      token: otpData["token"],
      ref_code: otpData["ref_code"],
      otp: otp,
    });
    if (res) {
      if (res["data"]["code"] === 200) {
        setOtpData(res["data"]["data"]["token"]);
        setIsMessage({ type: "success", data: res["data"]["message_th"] });

        clearInterval(otpData.intervalId);
        setTimeRemaining(0);

        setOtpConfirm(true);
      } else if (res["data"]["code"] === 400) {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      } else {
        setIsMessage({ type: "error", data: "OTP ผิด" });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  // newpass
  const handlePasswordChange = (e) => {
    setPassword(e);
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e);
  };

  const submit = async () => {
    if (!password) {
      setIsMessage({
        type: "warning",
        data: "กรุณากรอกรหัสผ่านที่ต้องการเปลี่ยน",
      });
      return;
    }
    if (!confirmPassword) {
      setIsMessage({ type: "warning", data: "กรุณากรอกยืนยันรหัสผ่าน" });
      return;
    }
    if (password !== confirmPassword) {
      setIsMessage({ type: "warning", data: "รหัสผ่านไม่ตรงกัน" });
      return;
    }
    let res = await publicApi.setNewPassword({
      token: otpData,
      password: password,
    });
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "เปลี่ยนรหัสผ่านสำเร็จ" });
        localStorage.clear();
        nav("/login");
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const iconDot = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="icon icon-tabler icons-tabler-filled icon-tabler-point"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z" />
      </svg>
    );
  };

  return (
    <>
      <div className="global-page">
        <HeadBar />
        <Breadcrumb pathItems={pathItems} />
        <div className="flex flex-col items-center gap-5 w-full">
          {otpConfirm ? (
            <>
              <div className="w-full text-center text-2xl mt-[100px] font-bold">
                ตั้งค่ารหัสผ่านใหม่
              </div>
              <div className="sm:w-full flex flex-col w-[60%]">
                <PasswordInput
                  regex={regex.password()}
                  placeholder="รหัสผ่านใหม่"
                  value={password}
                  setValue={handlePasswordChange}
                ></PasswordInput>
              </div>
              <div className="sm:w-full flex flex-col w-[60%]">
                <PasswordInput
                  regex={regex.password()}
                  placeholder="ยืนยันรหัสผ่านใหม่"
                  value={confirmPassword}
                  setValue={handleConfirmPasswordChange}
                ></PasswordInput>
              </div>

              <div className="sm:w-full flex flex-col w-[60%]">
                {password.length > 0 && (
                  <ul className="ms-2 text-[0.95rem]">
                    <li
                      className={
                        password.length > 0
                          ? regex.validateLengthPassword(password)
                          : "text-[#8f8e8e]"
                      }
                    >
                      <div className="flex items-center">
                        <div className="w-[25px]">
                          {password.length > 0
                            ? regex.iconLengthPassword(password)
                            : iconDot()}
                        </div>
                        <span>รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร</span>
                      </div>
                    </li>
                    <li
                      className={
                        password.length > 0
                          ? regex.validateNumberPassword(password)
                          : "text-[#8f8e8e]"
                      }
                    >
                      <div className="flex items-center">
                        <div className="w-[25px]">
                          {password.length > 0
                            ? regex.iconNumberPassword(password)
                            : iconDot()}
                        </div>
                        <span>รหัสผ่านต้องมีตัวเลข 1-9 อย่างน้อย 1 ตัว</span>
                      </div>
                    </li>
                    <li
                      className={
                        password.length > 0
                          ? regex.validateLowercasePassword(password)
                          : "text-[#8f8e8e]"
                      }
                    >
                      <div className="flex items-center">
                        <div className="w-[25px]">
                          {password.length > 0
                            ? regex.iconLowercasePassword(password)
                            : iconDot()}
                        </div>
                        <span>
                          รหัสผ่านต้องประกอบด้วยตัวอักษรพิมพ์เล็ก a-z อย่างน้อย
                          1 ตัว
                        </span>
                      </div>
                    </li>
                    <li
                      className={
                        password.length > 0
                          ? regex.validateUppercasePassword(password)
                          : "text-[#8f8e8e]"
                      }
                    >
                      <div className="flex items-center">
                        <div className="w-[25px]">
                          {password.length > 0
                            ? regex.iconUppercasePassword(password)
                            : iconDot()}
                        </div>
                        <span>
                          รหัสผ่านต้องประกอบด้วยตัวพิมพ์ใหญ่ A-Z อย่างน้อย 1 ตัว
                        </span>
                      </div>
                    </li>
                  </ul>
                )}
              </div>

              <div className="flex flex-col items-center gap-5 w-[60%] min-w-[267px]">
                <Button onClick={submit}>ตั้งรหัสผ่านใหม่</Button>
              </div>
            </>
          ) : (
            <>
              <div className="w-full flex justify-center items-center mt-[100px]">
                <div className="w-full text-center text-2xl font-bold">
                  ยืนยันรหัส OTP
                </div>
              </div>
              <div className="w-full text-center text-base font-bold">
                กรุณาใส่รหัส OTP ที่ได้รับจากหมายเลขโทรศัพท์ที่ยืนยัน
              </div>
              <div className="w-full text-center text-sm text-red-500">
                ระบบจะส่งรหัส OTP ไปยังหมายเลขโทรศัพท์ที่ยืนยัน
              </div>
              {timeRemaining !== 0 && (
                <div className="flex flex-row gap-1 w-full justify-center items-center">
                  <span className="text-xs font-bold">
                    {formatTime(timeRemaining, "รอ")}
                  </span>
                  <span className="text-xs text-[#F37F25] text-center font-bold">
                    ก่อนขอรหัสใหม่
                  </span>
                </div>
              )}
              <div>รหัสอ้างอิง : {otpData.ref_code}</div>
              <div className="sm:w-full flex flex-col w-[60%]">
                <Input
                  regex={regex.otp()}
                  label={"รหัส OTP"}
                  placeholder="กรอกรหัส OTP"
                  value={otp}
                  setValue={handleOtpChange}
                ></Input>
              </div>
              <div className="flex flex-col items-center gap-5 w-[60%] min-w-[267px]">
                <Button onClick={verifyOtp}>ยืนยัน</Button>
                <span
                  className="text-base text-blue-500 underline cursor-pointer"
                  onClick={() => generateOTP()}
                >
                  ขอรหัส OTP อีกครั้ง
                </span>
                <span className="text-base ">
                  ขอได้อีก {otpData?.otp_count} ครั้ง
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
